import { Color, PaletteColorOptions, PaletteOptions } from '@mui/material/styles';

const grey: Partial<Color> = {
  50: '#1c1c1c',
  100: '#2b2b2b',
  200: '#3a3a3a',
  300: '#4f4f4f',
  400: '#6b6b6b',
  500: '#7f7f7f',
  600: '#a0a0a0',
  700: '#c1c1c1',
  800: '#d5d5d5',
  900: '#eeeeee',
  A100: '#707070',
  A200: '#cccccc',
  A400: '#b0b0b0',
  A700: '#000000',
};

const primary: PaletteColorOptions = {
  light: '#8db9c8',
  main: '#5C92A6',
  dark: '#3a6c7e',
  contrastText: '#FFFFFF',
};

const secondary: PaletteColorOptions = {
  main: '#A68B6E',
  light: '#d0b89c',
  dark: '#7a624c',
  contrastText: '#FFFFFF',
};

const info: PaletteColorOptions = {
  main: '#6E8FA3',
  dark: '#4a6a81',
  light: '#9ab7cd',
  contrastText: '#FFFFFF',
};

const success: PaletteColorOptions = {
  main: '#8BAD75',
  dark: '#648f54',
  light: '#b7df9c',
  contrastText: '#FFFFFF',
};

const warning: PaletteColorOptions = {
  light: '#ffe6c4',
  main: '#D9A356',
  dark: '#a1773e',
  contrastText: '#000000',
};

const error: PaletteColorOptions = {
  light: '#fca1a1',
  main: '#D95F5D',
  dark: '#a64343',
  contrastText: '#FFFFFF',
};

const darkPalette: PaletteOptions = {
  mode: 'dark',
  // buildTheme merges this over a light theme, so every action color has to be named here.
  action: {
    active: '#fff',
    hover: 'rgba(255, 255, 255, 0.08)',
    selected: 'rgba(255, 255, 255, 0.16)',
    focus: 'rgba(255, 255, 255, 0.12)',
    disabled: 'rgba(255, 255, 255, 0.26)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
  },
  common: { black: '#000', white: '#fff' },
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  divider: '#D1D1D1',
  text: {
    primary: '#FFFFFF',
    secondary: '#cbd5e1',
    disabled: '#a0a0a0',
  },
  background: { paper: '#1c1c1c', default: '#121212' },
};

export default darkPalette;
